import { SVGProps, useMemo } from 'react';

import { useTheme } from '@/features/theme-switch';

const Close = (props: SVGProps<SVGSVGElement>) => {
  const { darkTheme } = useTheme();

  const color = useMemo(() => (darkTheme ? '#FFFFFF' : '#A0A8AA'), [darkTheme]);

  return (
    <svg
      width={16}
      height={16}
      fill="none"
      viewBox="0 0 16 16"
      stroke={color}
      {...props}
    >
      <path
        id="Vector"
        d="M3.5 3.5L12.5 12.5"
        stroke="current"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M3.5 12.5L12.5 3.5"
        stroke="current"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default Close;
